import React, { useEffect, useState } from 'react';
import ProductHomePageSectionModel from './models/ProductHomePageSectionModel';
import ProductHomePageSectionDetailsFields from './ProductHomePageSectionDetailsFields';

function AddProductHomePageSection({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new ProductHomePageSectionModel());

  useEffect(() => {
    const initial = new ProductHomePageSectionModel();
    setFormData(initial);
    if (onLoad) onLoad(initial);
  }, [onLoad]);

  return (
    <ProductHomePageSectionDetailsFields
      formData={formData}
      sendDataToParent={sendDataToParent}
    />
  );
}

export default AddProductHomePageSection;
